import { useEffect, useState } from "react";
import Stomp, { Client } from "@stomp/stompjs";

function Test() {
  const [stompClient, setStompClient] = useState(null);

  useEffect(() => {
    subscribe("")
  }, []);

  async function subscribe(channelId) {
    if(stompClient !== null) {
      try {
        await stompClient.deactivate();
      }
      catch(e) {
        console.log(e);
      }
    }
    const client = new Client({
      brokerURL: "http://localhost:5000/ws",
      // heartbeatIncoming: 30,
      // heartbeatOutgoing: 30
    });
    setStompClient(client);
    client.onConnect = (frame) => {
      client.subscribe("/sub/mfi-groups/" + "20", async (message) => {
        console.log(message);
      }, { Authorization: "Bearer YmVjMTdiYTYtZGViZS00YTk0LTliMWUtNTFhODBjNDdhYTM5" });
      client.onStompError = (frame) => {console.log(frame.headers)}
    }
    client.activate();
  }

  return (
    <div>

    </div>
  );
}

export default Test;